module.exports = __webpack_public_path__ + "img/mosquito.dba1c432.svg";